import style from './style.module.css';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

interface GuideUtuaProps {
  title: string;
  placeholder?: string;
}

const GuideUtua = ({ title, placeholder }: GuideUtuaProps) => {
  return (
    <div className={style.containerGuideUtua}>
      <div className={style.contentGuide}>
        <h3 className={style.guideTitle}>{title}</h3>
        <form
          className={style.formGuideUtua}
          method="get"
          action="https://chat.utua.com.br/pt-br/">
          <AutoAwesomeIcon className={style.iconInput} />
          <input
            aria-label="Type here your message"
            className={style.inputGuideUtua}
            name="q"
            type="text"
            placeholder={placeholder}
          />
          <button
            aria-label="Submit Question Button"
            className={style.buttonGuideUtua}>
            <SendRoundedIcon />
          </button>
        </form>
      </div>
    </div>
  );
};

export default GuideUtua;
